import "./resume.css";
import monito from "../img/monito3.png";
import resume from "../img/BuneyGakiya2025-1.jpg";
import React, { useState } from "react";

function Resume() {
  const [showResume, setShowResume] = useState(true);

  function handleClick() {
    setShowResume((...showResume) => {
      setShowResume(!showResume);
    });
    console.log(showResume);
  }

  function handleClick2() {
    setShowResume((...showResume) => {
      setShowResume(true);
    });
    console.log(showResume);
  }

  if (showResume === null) {
    return (
      <div className="resume">
      <div id="monito-container">
        <img src={monito} id="monis" onClick={handleClick} />
      </div></div>
    );
  } else
    return (
      <div className="resume">
        {showResume ? (
          <div id="monito-container">
            <img src={monito} id="monis" onClick={handleClick} />
          </div>
        ) : (
          <img src={resume} id="curriculum" onClick={handleClick2} />
        )}
      </div>
    );
}

export default Resume;
